<h1 class="email-form-title text-primary-blue-700">Email sent!</h1>
<p>{{ message }}</p>
<button
  pButton
  type="submit"
  label="Back to sign in"
  class="w-full"
  (click)="onSubmit()"
  data-cy="submit-button"
></button>
<app-mobile-footer></app-mobile-footer>
